import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkCard, UitkCardLink, UitkCardContentSection } from "uitk-react-cards";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkBadge, UitkBadgeTheme, UitkBadgeSize } from "uitk-react-badge";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";

import HotelRating from "../shared/HotelRating";
import CardTitle from "../shared/CardTitle";
import AddressAndNeighborhood from "../shared/AddressAndNeighborhood";
import PricesAndDate from "../shared/PricesAndDate";
import DescriptionAndGuestReviewSectionWrapper from "../shared/DescriptionAndGuestReviewSectionWrapper";
import LobDetails from "../shared/LobDetails";
import LobBadge from "../shared/LobBadge";
import { ReviewCountAndRating } from "components/flexComponents/Hotels/components/ReviewCountAndRating";

import { TrackedLink } from "components/utility/analytics/TrackedLink";

import { PackageCardProps } from "components/flexComponents/Packages/typings";

export const PackageCardImageLeft = ({ packageItem, index, language }: PackageCardProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkCard padded>
        <UitkLayoutGrid columns={2}>
          <UitkSpacing margin={{ inlineend: "two" }}>
            <UitkLayoutGridItem colSpan={1}>
              <div>
                <UitkFigure
                  ratio={UitkFigureAspectRatioType.R16_9}
                  className="uitk-card-roundcorner-all"
                  imageFit="cover"
                >
                  <UitkImage src={packageItem.hotelImageUrl} alt={packageItem.hotelName} placeholderImage />
                  <UitkLayoutPosition type="absolute" position={{ top: "two", left: "two" }}>
                    <UitkSpacing padding="one">
                      <UitkBadge theme={UitkBadgeTheme.FAMILY_FRIENDLY} size={UitkBadgeSize.SMALL}>
                        <LobBadge />
                      </UitkBadge>
                    </UitkSpacing>
                  </UitkLayoutPosition>
                </UitkFigure>
              </div>
            </UitkLayoutGridItem>
          </UitkSpacing>
          <UitkLayoutGridItem colSpan={1}>
            <UitkSpacing padding={{ inline: "three" }}>
              <UitkCardContentSection padded={false}>
                <UitkLayoutFlex justifyContent="space-between">
                  <UitkLayoutFlexItem>
                    <UitkText overflow="truncate">
                      <HotelRating rating={packageItem.hotelStarRating} isText />
                      <CardTitle cardTitle={packageItem.hotelName} />
                      <AddressAndNeighborhood packageItem={packageItem} />
                      {packageItem.showHotelGuestRating && (
                        <ReviewCountAndRating
                          hotelOverallReviewRating={Number(packageItem.hotelReviewScore)}
                          reviewCount={Number(packageItem.hotelReviewTotal)}
                          language={language}
                        />
                      )}
                      <LobDetails packageItem={packageItem} />
                    </UitkText>
                  </UitkLayoutFlexItem>
                  <UitkLayoutFlexItem>
                    <UitkText overflow="truncate">
                      <PricesAndDate packageItem={packageItem} renderSavingBadge renderDates={false} />
                    </UitkText>
                  </UitkLayoutFlexItem>
                </UitkLayoutFlex>
                <DescriptionAndGuestReviewSectionWrapper packageItem={packageItem} language={language} marginOnTop />
                <UitkCardLink>
                  <TrackedLink
                    className="uitk-card-link"
                    data-testid={`packagecard-desktop-image-left-link-${index}`}
                    rfrr={`card-${index}`}
                    href={packageItem.shopUrl}
                    aria-label={formatText("package.card.ariaLabel.fh")}
                    moduleName="packages"
                  />
                </UitkCardLink>
              </UitkCardContentSection>
            </UitkSpacing>
          </UitkLayoutGridItem>
        </UitkLayoutGrid>
      </UitkCard>
    </UitkSpacing>
  );
};
